import React from 'react';

import { SurveysTabBarIconWithBadge } from './SurveysTabBarIconWithBadge';
import { useGetSurveysTotalCountQuery } from '../../graphql/types.generated';

export const SurveysTabBarIconWithBadgeController = () => {
  const { data } = useGetSurveysTotalCountQuery();
  return <SurveysTabBarIconWithBadge totalCount={data?.surveys.totalCount || 0} />;
};
